import { writable } from "svelte/store";

//localStorage.workspace = JSON.stringify({})

let stored_workspace = localStorage.getItem("workspace");

if (!stored_workspace) {
    localStorage.setItem("workspace", JSON.stringify({}));
    stored_workspace = localStorage.getItem("workspace");
}

export const active_workspace = writable(JSON.parse(stored_workspace));

active_workspace.subscribe(value => {
    //stored_workspace = JSON.stringify(value)
    localStorage.setItem("workspace", JSON.stringify(value))
});